const WillowWaltz = {
    name: "Willow Waltz",
    bpm: 138,
    signature: "3/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default WillowWaltz;